import {BasicEntity} from '../message/BasicEntity';
import {BasicScenario} from './BasicScenario';

export class DuplicationWrapper <T extends BasicEntity, SCEN extends BasicScenario> {
entity: T;
errorCode: string;
mode: string;
scenario: SCEN;
status: string;
}

